import React, { MouseEvent } from 'react';

import appearance from './assets/appearance.gif';
import { Root } from './index.styled';

const BackToTopButton = () => {

  function goTop(event: MouseEvent<HTMLAnchorElement>) {
    event.preventDefault();
    window.scroll(0, 0);
  }

  return (
    <Root>
      <a href="" onClick={goTop}><img src={appearance} alt="ページの先頭へ" /></a>
    </Root>
  );
};

export default BackToTopButton;
